import React from "react";
import { AccountVerification, LoginForm } from "@hedgefund/shared";
import {
  loginAction,
  phoneVerify,
  resendTwoFactorCode,
  twoFactor,
  twoFactorCodeToEmail,
} from "./actions";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { setDefaultHeader } from "../../../services/axiosClient";
import LoginError from "@hedgefund/shared/src/LoginError";

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const loginState = useSelector((state) => state.login);

  const onSuccess = (path) => {
    history.push({
      pathname: `/${path}`,
    });
  };

  const callBack = history.location.pathname + history.location.search;
  const url = callBack.split("?callback=")[1];

  const onSubmitTwoFactorCode = (value) => {
    dispatch(
      twoFactor({
        code: value,
        token: loginState.token,
        onSuccess: () => onSuccess(url ? url : "dashboard"),
      })
    );
  };
  const sendOTPToEmailAddress = () => {
    dispatch(
      twoFactorCodeToEmail({
        userId: loginState.userId,
      })
    );
  };
  const sentTwoFactorCode = () => {
    dispatch(
      resendTwoFactorCode({
        is2FA: loginState.isPhoneVerified,
        userId: loginState.userId,
      })
    );
  };
  const verifyCode = (value) => {
    if (loginState.isTFVRequired === true) {
      onSubmitTwoFactorCode(value);
    } else {
      dispatch(
        phoneVerify({
          code: value,
          token: loginState.token,
          onSuccess: () => onSuccess("dashboard"),
        })
      );
    }
  };

  return loginState.isTFVRequired || !loginState.isPhoneVerified ? (
    <AccountVerification
      onSubmit={verifyCode}
      // resendAction={sentTwoFactorCode}
      loginState={loginState}
      sendOTPToPhone={sentTwoFactorCode}
      sendOTPToEmail={sendOTPToEmailAddress}
    />
  ) : loginState.loginFailed ? (
    <LoginError
      heading="Fund Login"
      text="Your account is currently pending and someone from the FCN team will reach out shortly for next steps. Thank you"
    />
  ) : (
    <LoginForm
      loading={loginState.loading}
      loginTitle="Fund Login"
      history={history}
      onSubmit={(data) => {
        const body = {
          userNameOrEmailAddress: data.email,
          password: data.password,
        };
        dispatch(
          loginAction(body, () => {
            setDefaultHeader();
            history.push({
              pathname: url ? "/" + url : "/dashboard",
            });
          })
        );
      }}
    />
  );
};

export default Login;
